<template>
  <div>

  </div>
</template>

<script>
import { yiDongPb, newYiDong, lianTong } from '@/api/api.js'
import { Toast } from 'vant'
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {
    tb () {
      const that = this
      const carrier = this.$store.state.carrier
      switch (carrier) {
        case '移动PB': that.refreshAxiosYDPb(this.$route.params.iccid); break
        case '联通': that.refreshAxiosLT(this.$route.params.iccid); break
        case '移动CT': that.refreshAxiosYDCT(this.$route.params.iccid); break
      }
    },
    changURL () {
      this.$router.push({
        name: 'Recharge',
        params: {
          iccid: this.$route.params.iccid
        }
      })
    },
    // 移动PB 同步函数
    async refreshAxiosYDPb (iccid) {
      const { data: res } = await yiDongPb({ iccid: this.$route.params.iccid })
      if (res.code === 1) {
        Toast.clear()
        this.changURL()
      }
    },
    // 新移动(移动CT 同步函数
    async refreshAxiosYDCT (iccid) {
      const { data: res } = await newYiDong({ iccid: this.$route.params.iccid })
      if (res.code === 1) {
        Toast.clear()
        this.changURL()
      }
    },
    // 联通 同步函数
    async refreshAxiosLT (iccid) {
      const { data: res } = await lianTong({ iccid: this.$route.params.iccid })
      if (res.code === 1) {
        Toast.clear()
        this.changURL()
      }
    }
  },
  beforeCreate () {},
  created () {
    Toast.loading({
      duration: 0,
      forbidClick: true,
      loadingType: 'spinner',
      message: '同步数据中...'
    })
    if (this.$store.state.type === 'queryRecharge') {
      this.$store.commit('setType', 'recharge')
      this.tb()
    } else {
      this.$store.commit('setType', 'recharge')
      this.$router.push({
        name: 'Recharge',
        params: {
          iccid: this.$route.params.iccid
        }
      })
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
</style>
